import scorableItemNumberingService from '../../../../services/questionView/ScorableItemNumberingService';

const interactionNumberSelector = {
    selectNumberClassList(number, questionContentRevisionId, flaggedItems) {
        if (number === null || number === undefined) {
            return '';
        }

        const isActive = scorableItemNumberingService.isActiveScorableItem(number);
        const isFlagged = flaggedItems && flaggedItems.includes(`${questionContentRevisionId}-${number}`);
        const classList = ['inline', 'choiceOrderNumber'];

        if (isActive) {
            classList.push('active');
        }

        if (isFlagged) {
            classList.push('flagged');
        }

        return classList.join(' ');
    },

    selectProps(ownProps) {
        const {
            modelIdentifier,
            questionContentRevisionId,
            flaggedItems,
            choiceIdentifier,
        } = ownProps;

        const number = scorableItemNumberingService.getInteractionChoiceNumber(questionContentRevisionId, modelIdentifier, choiceIdentifier);

        return {
            number,
            numberClassList: this.selectNumberClassList(number, questionContentRevisionId, flaggedItems),
            scorableItemId: `scorableItem-${questionContentRevisionId}_${number}`,
        };
    },
};

export default interactionNumberSelector;
